import {TokenCredentials} from '../login/tokencredentials';
import {Location} from './location';
import {BinType} from './bintype';

export class Bin {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    binType : BinType;
	location : Location;
	barcode : string;
	weight : number;

    created : Date;
    updated : Date;
    version : number;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/bin.ts